export default [
  {
    path: "/sxfgeQaJ51OP00nLALkd",
    children: [
    {
        path: "g6eIKzsMH5bN",
        name: "staffList",
        meta: {
          title: "Staff",
          authRequired: true,
          acc: ["y67982"],
        },
        component: () => import("../views/staff/list.vue"),
      },
      {
        path: "zgUt44fUeiHs/:tr",
        name: "viewStaff",
        meta: {
          title: "View Staff",
          authRequired: true,
          acc: ["y68075"],
        },
        component: () => import("../views/staff/view.vue"),
      },
      {
        path: "TTYttoRCkhRE/:tr",
        name: "updateStaff",
        meta: {
          title: "Update Staff",
          authRequired: true,
          acc: ["y79424"],
        },
        component: () => import("../views/staff/update.vue"),
      },
      {
        path: "32ncLKV9gDJx/:tr",
        name: "updateStaffPassword",
        meta: {
          title: "Update Staff Password",
          authRequired: true,
          acc: ["y79424"],
        },
        component: () => import("../views/staff/updatePassword.vue"),
      },
      {
        path: "IaO3ZMw8rPYX/:tr",
        name: "updateStaffRole",
        meta: {
          title: "Update Staff Role",
          authRequired: true,
          acc: ["y79424"],
        },
        component: () => import("../views/staff/updateRole.vue"),
      },
      {
        path: "agd34tmd7fdU",
        name: "newStaff",
        meta: {
          title: "New Staff",
          authRequired: true,
          acc: ["y76403"],
        },
        component: () => import("../views/staff/new.vue"),
      },
      
      
    ],
  },
];
